// extracted by mini-css-extract-plugin
module.exports = {"avatarContainer":"styles_avatarContainer__2ZIRW"};